import { h } from "./../../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
export default function (ComposedComponent) {
    var _a;
    return _a = (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.getValue = function () {
                    var _a = _this.props, children = _a.children, selectedValue = _a.selectedValue;
                    if (selectedValue && selectedValue.length) {
                        return selectedValue;
                    }
                    else {
                        if (!children) {
                            return [];
                        }
                        return React.Children.map(children, function (c) {
                            var cc = React.Children.toArray(c.children || c.props.children);
                            return cc && cc[0] && cc[0].props.value;
                        });
                    }
                };
                _this.onChange = function (i, v, cb) {
                    var value = _this.getValue().concat();
                    value[i] = v;
                    if (cb) {
                        cb(value, i);
                    }
                };
                _this.onValueChange = function (i, v) {
                    _this.onChange(i, v, _this.props.onValueChange);
                };
                _this.onScrollChange = function (i, v) {
                    _this.onChange(i, v, _this.props.onScrollChange);
                };
                return _this;
            }
            class_1.prototype.render = function () {
                return (h(ComposedComponent, __assign({}, this.props, { getValue: this.getValue, onValueChange: this.onValueChange, onScrollChange: this.props.onScrollChange && this.onScrollChange })));
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = {
            prefixCls: 'rmc-multi-picker',
            onValueChange: function () { },
        },
        _a;
}
